module.exports = __webpack_public_path__ + "static/media/google-play.a39d194f.svg";